export default __webpack_public_path__ + "static/media/loginBackground.0db9c3dc.png";